// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"f3d4ca72","537":"099e518d","726":"c40038a8","787":"1f8e4194"}[chunkId] + ".chunk.js";
};